import React from 'react';

import { BUCKETS } from '../constants';

/**
 * The onboarding view's tabs, each with its row count and tint: the carrier tabs unless `buckets` says otherwise.
 *
 * @param {{ buckets?: object[], activeKey: string, counts: Object<string, number>, onSelect: (key: string) => void }}
 *   props
 */
const BucketTabs = ({ buckets = BUCKETS, activeKey, counts, onSelect }) => (
    <div role="tablist" className="flex items-end gap-1.5">
        {buckets.map((bucket) => {
            const active = bucket.key === activeKey;
            return (
                <button
                    key={bucket.key}
                    type="button"
                    role="tab"
                    aria-selected={active}
                    onClick={() => onSelect(bucket.key)}
                    className={[
                        'rounded-t-md border border-b-0 px-3 text-[12px] font-medium',
                        bucket.tabClass,
                        // The active tab sits over the panel's top border, in the panel's colour, so the two read as
                        // one piece. Without z-index the panel, drawn later, paints its border across the tab.
                        active ? 'relative z-10 -mb-px py-2' : 'py-1.5 opacity-80',
                    ].join(' ')}
                >
                    <span className="font-bold">{counts?.[bucket.key] ?? 0}</span> {bucket.label}
                </button>
            );
        })}
    </div>
);

export default BucketTabs;
